// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"8b683164","141":"60fa53ae","235":"cb877e7c","395":"7b655f36","453":"a255cb81","522":"3d4986eb","671":"80b0b993","683":"5f687885","731":"9888aa9d","744":"b3fc5062","777":"59e780da","810":"20da416c","827":"24a7db96","885":"11b187d7"}[chunkId] + ".chunk.js";
};